import * as React from 'react';
import { Container, TituloSecao } from './styles';
import userContext from '../../Context/UserContext';
import { useContext } from 'react';
import Grid from '../../componentes/Grid';
import { useParams } from 'react-router-dom';

const Lancamento = (

) => {
  const currentlyUser = useContext(userContext);
  const { Codcliente, Codempresacli } = currentlyUser.user;

  return (
    <Container>
      <TituloSecao>
        Lançamentos
      </TituloSecao>
      <Grid Titulo={"Lançamentos"} Lancamento={1} Codcliente={Codcliente} Codempresacli={Codempresacli} />
    </Container>
  )
};

export default Lancamento;
